
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Tree as ElTree } from 'element-ui'
import { roleByid, roleByappId, authorize } from '@/api/account'
import { InitModule } from '@/store/modules/init'
import { UserModule } from '@/store/modules/user'

interface RolesProps {
  id: number
  name: string
}

// 角色列表根据平台id
interface RoleListResponse {
  id: number
  name: string
  roles: RolesProps[]
}

// 角色列表根据账号id
interface RoleResponse {
  pid: number
  roleId: number
  name: string
}

// 树结构
interface NodeProps {
  id?: number
  label: string
  children?: NodeProps[]
}

@Component({
  name: 'AuthModal'
})
export default class extends Vue {
  @Prop({ default: false }) authDialogFlag!: boolean
  @Prop() id!: number
  private visible = false
  private loading = false
  private appId = 0
  private allRoleList: NodeProps[] = []
  private holdRoleList: number[] = []

  get appList() {
    return InitModule.appList
  }

  get adminId() {
    return UserModule.userInfo.adminId
  }

  // 初始化
  private async init() {
    this.loading = true
    const { content: all } = await roleByappId<RoleListResponse[]>({ appId: this.appId }) // 所有的
    this.allRoleList = all.map(item => ({
      label: item.name,
      children: item.roles.map(role => ({ label: role.name, id: role.id }))
    })).filter(item => item.children.length !== 0)
    const { content: hold } = await roleByid<RoleResponse[]>({ appid: this.appId, id: this.id,appId: this.appId, }) // 已拥有的
    // 回显
    this.holdRoleList = hold.map(item => item.roleId)
    this.$nextTick(() => (this.$refs.tree as ElTree).setCheckedKeys(this.holdRoleList, true))
    this.loading = false
  }

  // 选择平台
  private change() {
    this.init()
  }

  private close() {
    this.$emit('update:authDialogFlag', false)
  }

  private async onSubmit() {
    const roleIds = (this.$refs.tree as ElTree).getCheckedKeys(true)
    await authorize({ roleIds, adminId: this.id, appId: this.appId })
    this.$message.success('授权成功')
    this.close()
  }

  @Watch('authDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.authDialogFlag
    if (this.visible) {
      // 回填所持有权限
      if (this.id) {
        await InitModule.GetAppList()
        if (this.appList.length > 0) this.appId = this.appList[0].id
        this.init()
      }
    }
  }
}
